import React, { useEffect, useRef, useState } from 'react';
import './integration.scss';

import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getJsonFromStorage,
  getPaginationOpts, getResponseError,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import {
  archiveCheckTypes, deleteCheckTypes, loadCheckTypesById, loadCheckTypesList, unarchiveCheckTypes,
} from '../actions';
import { getSystemData } from '../../System/reducer';
import { getIntegrationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { statusFormatter, dateTimeFormatter } from '../../../utils/formatters';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import { CHECK_TYPE_STATUS_LIST, CHECK_TYPE_STATUS_NAMES } from '../../../configs';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import CheckTypesForm from './CheckTypesForm';
import { showGlobalConfirm } from '../../System/actions';
import CheckTypesView from './CheckTypesView';
import { INTEGRATION_MODULE } from '../../../configs/moduleNames';
import getDefaultSort from '../../../utils/getDefaultSort';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';

export default function CheckTypesPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const { updatePeriod } = useSelector(getSystemData);
  const {
    checkTypesListMeta,
    loadingCheckTypesList,
    checkTypesList,
    loadingCurrentCheckTypes,
    currentCheckTypes,
    loadingEditCheckTypes,
    loadingArchiveCheckTypes,
    loadingUnarchiveCheckTypes,
    loadingDeleteCheckTypes,
    loadingCreateCheckTypes,
  } = useSelector(getIntegrationData);
  const [isShow, setIsShow] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const defaultFilterValues = { search: '', created_at: '' };
  const { watch, getValues, control } = useForm({ defaultValues: getJsonFromStorage('check-types-filter', defaultFilterValues) });
  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[INTEGRATION_MODULE].checkTypesListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    const p1 = dispatch(loadCheckTypesList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadCheckTypesById(item.id))
      .then(() => {
        setIsShowForm(true);
        setIsEdit(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  const handleShow = item => event => {
    if (!item) {
      return;
    }
    dispatch(loadCheckTypesById(item.id))
      .then(() => {
        setIsShow(true);
      })
      .catch(response => errorNotification('Загрузка записи', getResponseError(response)));
    return false;
  };

  const handleArchive = item => event => {
    if (!item) {
      return;
    }
    const action = item.is_archive ? unarchiveCheckTypes : archiveCheckTypes;
    dispatch(action(item.id))
      .then(() => {
        loadData();
        successNotification('Архивация шаблона', 'Архивация прошла успешно');
      })
      .catch(response => errorNotification('Архивация шаблона', getResponseError(response)));
    return false;
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление шаблона "${item.name || ''}"`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteCheckTypes(item.id)).then(() => {
        loadData();
        successNotification('Удаление шаблона', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление шаблона', getResponseError(response));
      });
    }).catch(() => {});
    return false;
  };

  const handleClose = () => {
    setIsShowForm(false);
    setIsEdit(false);
    setIsShow(false);
  };

  const columns = [
    {
      dataField: 'name',
      text: 'Запрашиваемая информация',
    },
    {
      dataField: 'service_name',
      text: 'Наименование сервиса',
    },
    {
      dataField: 'source',
      text: 'Источник',
      headerClassName: 'source-column',
    },
    {
      dataField: 'created_at',
      text: 'Дата создания',
      formatter: dateTimeFormatter,
    },
    {
      dataField: 'status',
      text: 'Статус электронного дела',
      formatter: a => statusFormatter(a, 'check.type.status', CHECK_TYPE_STATUS_NAMES),
    },
  ];

  useEffect(() => {
    const subscription = watch(values => {
      loadData({ page: 1 });
      localStorage.setItem('check-types-filter', JSON.stringify(values));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const renderContextMenu = item => (
    <div className="more-wrapper">
      <Button variant="link" className="w-100 more-button" onClick={handleShow(item)}>
        Просмотр
      </Button>
      <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
        Редактировать
      </Button>
      {/* <Button variant="link" className="w-100 more-button" onClick={handleArchive(item)}> */}
      {/*  {item.is_archive ? 'Перевести в активный' : 'Перевести в архивный'} */}
      {/* </Button> */}
      <Button variant="link" className="w-100 more-button" onClick={handleDelete(item)}>
        Перевести в удаленные
      </Button>
    </div>
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={renderContextMenu(item)}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const [sort, setSort] = useState(getDefaultSort(columns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  return (
    <div className="page application-page">
      <TimerLoader global loading={loadingCheckTypesList || loadingCurrentCheckTypes || loadingEditCheckTypes || loadingArchiveCheckTypes || loadingUnarchiveCheckTypes || loadingDeleteCheckTypes || loadingCreateCheckTypes} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.integration.request.template' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <FieldDTO
            control={control}
            component={CustomSelectInput}
            dtoObject={{
              name: 'status',
              type: String,
              labelKey: 'status',
            }}
            className="no-border"
            addPlaceholder
            options={CHECK_TYPE_STATUS_LIST}
          />
          <div className="filter-sep" />
          <Button variant="second" className="" onClick={() => { setIsShowForm(true); setIsEdit(false); }}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={checkTypesList}
                columns={columns}
                name="check-types-list"
                settingsFormatter={moreFormatter}
                renderContextMenu={renderContextMenu}
                onDoubleClickByRow={(item, event) => handleShow(item)(event)}
                changeSort={changeSort}
                rowClassFormatter={rowClassFormatter}
                sort={sort}
              />
            </div>
          </div>
          <Pagination meta={checkTypesListMeta} list={checkTypesList} handleChangeMeta={loadData} />
        </div>
      </div>
      {isShowForm ? <CheckTypesForm key={currentCheckTypes && currentCheckTypes.id} isEdit={isEdit} current={currentCheckTypes} loadData={loadData} close={handleClose} /> : null}
      {isShow ? <CheckTypesView key={currentCheckTypes && currentCheckTypes.id} current={currentCheckTypes} close={handleClose} /> : null}

    </div>
  );
}
